export enum FalEventTypes {
  RouteChanged = 'CommonSpirit.FindALocation.RouteChanged'
}
